<footer class="footer">
  <div class="container">
    <div class="left-side">
      <div class="logo" [style.background-image]="'url(' + brandData().footerLogoImage + ')'">
      </div>
      <div class="helpdesk">
        @if (brandData().helpdeskLabel || brandData().helpdeskPhone || brandData().helpdeskEmail) {
        <div class="helpdesk-info">
          <span [class]="brandData().helpdeskEmail ? 'helpdesk-phone' : null">
            @if (brandData().helpdeskLabel; as label) {
            <span class="label">{{ label }}</span>
            }
            @if (brandData().helpdeskPhone; as phone) {
            <span class="phone">{{ phone }} </span>
            }
            @if (brandData().helpdeskPhoneHint; as helpdeskPhoneHint) {
            <span class="phone-hint">{{ helpdeskPhoneHint }}</span>
            }
          </span>
          @if (brandData().helpdeskEmail; as helpdeskEmail) {
          <span class="email">
            <a href="mailto:{{helpdeskEmail}}">{{ helpdeskEmail }}</a>
          </span>
          }
        </div>
        }
        <div class="helpdesk-links">
          <span>
            <a class="privacy-policy" href="https://compassinternationalholdings.com/privacy-policy"
              target="_blank">Privacy Policy</a>
          </span>
          <span>
            <a class="terms-of-use" href="https://compassinternationalholdings.com/tos" target="_blank">Terms of Use</a>
          </span>
          <span>
            <span class="copy-rights">{{ brandData().copyright }}<span class="a-tag-padding">
                <ng-content /></span></span>
          </span>
        </div>
      </div>
    </div>
    <div class="social-media-links">
      <ol>
        @if (brandData().facebookLink; as facebookLink) {
        <li>
          <a class="notifications-button" [href]="facebookLink"><mat-icon aria-label="Facebook"
              svgIcon="facebook" /></a>
        </li>
        }
        @if (brandData().twitterLink; as twitterLink) {
        <li>
          <a class="notifications-button" [href]="twitterLink"><mat-icon aria-label="Twitter" svgIcon="twitter" /></a>
        </li>
        }
        @if (brandData().instagramLink; as instagramLink) {
        <li>
          <a class="notifications-button" [href]="instagramLink"><mat-icon aria-label="Instagram"
              svgIcon="instagram" /></a>
        </li>
        }
        @if (brandData().youtubeLink; as youtubeLink) {
        <li>
          <a class="notifications-button" [href]="brandData().youtubeLink"><mat-icon aria-label="Youtube"
              svgIcon="youtube" /></a>
        </li>
        }
      </ol>
    </div>
  </div>
</footer>